import { useEffect, useState } from 'react';
import { supabase } from '../integrations/supabase/client';
import { WifiOff, Wifi } from 'lucide-react';

interface ConnectionHealthMonitorProps {
  onConnectionChange?: (isConnected: boolean) => void;
}

export const ConnectionHealthMonitor = ({ 
  onConnectionChange 
}: ConnectionHealthMonitorProps) => {
  const [isConnected, setIsConnected] = useState(true);

  useEffect(() => {
    // A single lightweight channel, no presence pings: the old 30s track()
    // heartbeat was a large share of the project's realtime message usage.
    const subscription = supabase
      .channel('connection_health')
      .subscribe((status) => {
        const connected = status === 'SUBSCRIBED';
        setIsConnected(connected);
        onConnectionChange?.(connected);
      });

    return () => {
      supabase.removeChannel(subscription);
    };
  }, [onConnectionChange]);

  return (
    <div className={`flex items-center gap-1 ${isConnected ? 'text-green-500' : 'text-amber-500'}`}>
      {isConnected ? <Wifi size={16} /> : <WifiOff size={16} />}
      <span className="text-sm">{isConnected ? 'Connected' : 'Connection issues'}</span>
    </div>
  );
};
